<template>
  <Section id="step-three">
    <Counter>3</Counter>
    <Heading>Import Discord data to Slack</Heading>
    <Description>
      Upload the archive from <a class="not-decorated" href="#step-two"><code>Step 2</code></a> via native Slack import tool. Your channels will get automatically created.
      <br>You will be offered to invite new users to your Slack board or merge them with existing ones.
      <br>
      <br>
      <div class="warning">
        <strong>Note: </strong>Please, be patient, the import may take several minutes.
      </div>
    </Description>
    <Action>
      <a class="btn btn--primary" :class="{'is-disabled': disabled}" href="https://my.slack.com/services/import/slack" target="_blank">Use Slack importing tool</a>
    </Action>
  </Section>
</template>

<script>
  import Section from './UI/Section'
  import Heading from './UI/Heading'
  import Description from './UI/Description'
  import Counter from './UI/Counter'
  import Action from './UI/Action'

  export default {
    components: {
      Section,
      Heading,
      Description,
      Counter,
      Action
    },
    props: ['disabled'],
  }
</script>

<style lang="scss" scoped>
 
</style>
